import {
  Button,
  ButtonBase,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import StarIcon from '@material-ui/icons/Star'
import TrendingFlatOutlinedIcon from '@material-ui/icons/TrendingFlatOutlined'
import { useHistory, useParams } from 'react-router-dom'

import NoPictureDeafault from '../../../../assets/images/NoPictureDeafault.png'
import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate, lang } from '../../../../localization'
import { LocalizedLink } from '../../../../routes/localizedRoutes'
import {
  EntityBasicDetails,
  SearchAvailabilityInput,
  SearchAvailabilityResponse
} from '../../../../types/searchAvailability'
import useStyles from './styles/index.styles'

type Props = {
  data: EntityBasicDetails
  searchAvailability: SearchAvailabilityResponse | undefined
  searchAvailabilityInput: SearchAvailabilityInput
}

const HotelContainer = ({
  data,
  searchAvailability,
  searchAvailabilityInput
}: Props) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const history = useHistory()
  const params = useParams<{ channelId: string; code: string; name: string }>()

  const currency = searchAvailability?.currency
  const guestCount = searchAvailability?.guestCount
  const lengthOfStay = searchAvailability?.lengthOfStay

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <img
          className={classes.image}
          src={data.images.length > 0 ? data.images[0] : NoPictureDeafault}
        />
        <div className={classes.ratingConainer}>
          <StarIcon className={classes.ratingIcon} />
          <Typography
            variant={isMobile ? 'h6' : 'h5'}
            className={classes.iconText}>
            {data.starClass}
          </Typography>
        </div>
      </div>
      <div
        className={classes.detailsContainer}
        onClick={() => {
          if (isMobile) {
            history.push(
              `/book/${params.channelId}/${params.code}/${
                params.name
              }/hotel/?filter=${encodeURIComponent(
                JSON.stringify({
                  ...searchAvailabilityInput,
                  cityID: undefined,
                  propertyCode: data.propertyCode
                })
              )}`
            )
          }
        }}>
        <div className={classes.nameAndAddressContainer}>
          <div className={classes.hotelName}>
            <Typography variant="h3" className={classes.title}>
              {data.propertyName}
            </Typography>
          </div>
          {!isMobile && (
            <div className={classes.hotelLocation}>
              <Typography className={classes.verticalAlign} variant="h5">
                <PlaceOutlinedIcon className={classes.icon} /> {data.address}
              </Typography>
            </div>
          )}

          {!isMobile && (
            <div className={classes.hotelFacilities}>
              {data?.facilities.slice(0, 5).map((f, i) => (
                <Typography className={classes.facility} variant="h5" key={i}>
                  {f.Name}
                  {data?.facilities.length !== i + 1 && getTranslate(',')}
                </Typography>
              ))}
              {data?.facilities.length > 7 && (
                <Tooltip
                  title={data.facilities
                    .slice(5)
                    .map((f) => f.Name)
                    .join(', ')}
                  placement="top"
                  arrow>
                  <Typography className={classes.facility} variant="h5">
                    +{data.facilities.length - 7} {getTranslate('more')}
                  </Typography>
                </Tooltip>
              )}
            </div>
          )}
        </div>
        <div className={classes.priceDetailsContainer}>
          <div className={classes.leftSideContainer}>
            <Typography className={classes.textColor} variant="h5">
              {`${lengthOfStay} ${getTranslate(
                'Nights'
              )}, ${guestCount} ${getTranslate('Guests')}`}
            </Typography>
            <Typography variant="h3" className={classes.price}>
              {` ${addCommaToPrice(data.bestAvailableRate)} ${getTranslate(
                currency || ''
              )}`}
            </Typography>
            <Typography className={classes.textColor} variant="h5">
              {getTranslate('Start From')}
            </Typography>
          </div>
          {!isMobile && (
            <div className={classes.bottonContainer}>
              <ButtonBase
                component={LocalizedLink}
                to={`/book/${params.channelId}/${params.code}/${
                  params.name
                }/hotel/?filter=${encodeURIComponent(
                  JSON.stringify({
                    ...searchAvailabilityInput,
                    cityID: undefined,
                    propertyCode: data.propertyCode
                  })
                )}`}>
                <Button
                  variant="outlined"
                  className={classes.btn}
                  endIcon={
                    <TrendingFlatOutlinedIcon
                      style={{
                        transform: lang === 'fa' ? 'rotate(180deg)' : 'none'
                      }}
                      className={classes.icon}
                    />
                  }>
                  <Typography variant="h4" className={classes.btnText}>
                    {getTranslate('Book Now')}
                  </Typography>
                </Button>
              </ButtonBase>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default HotelContainer
